import moment from 'moment';
import I18n from 'i18n-js';

export const translateDateTime = (timeStamp, format) => {
  const currentLocale = I18n.locale || 'en';
  return moment(timeStamp)
    .locale(currentLocale)
    .format(format);
};

export default translateDateTime;
